export const genericConstants = {
  SET_DEFAULT_LANGUAGE: 'SET_DEFAULT_LANGUAGE',
}
